var render, staticRenderFns
import script from "./DisputeStatus.vue?vue&type=script&lang=js"
export * from "./DisputeStatus.vue?vue&type=script&lang=js"
import style0 from "./DisputeStatus.vue?vue&type=style&index=0&id=5e6bbf0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6bbf0c",
  null
  
)

export default component.exports